import AdministrativeAgentForm from './AdministrativeAgentForm';

export default AdministrativeAgentForm;
